import { CreditStudyId, RiskStudyDocumentType, UserId } from './types';

export class ExposedDocumentation {
  constructor(
    public readonly id: DocumentationId,
    public readonly userId: UserId,
    public readonly creditStudyId: CreditStudyId,
    public readonly isComplete: DocumentsCompleted,
    public readonly type: DocumentationType,
    public readonly status: DocumentationStatus,
    public readonly requiredDocuments: RiskStudyDocumentType[],
    public readonly documents: DocumentUploaded[]
  ) {}
}

export class ExposedDocumentationModel {
  static canEditDocuments = (documentation: ExposedDocumentation): boolean => {
    const isDocumentationCompleted = !!documentation.isComplete.value;
    const isDocumentationApproved = documentation.status === DocumentationStatus.APPROVED;
    return !(isDocumentationApproved || isDocumentationCompleted);
  };

  static isUserDone = (documentation: ExposedDocumentation): boolean =>
    documentation.isComplete.value || DocumentationStatus.APPROVED === documentation.status;
}

export enum DocumentationStatus {
  PRISTINE = 'PRISTINE',
  APPROVED = 'APPROVED',
  REVIEW_PENDING = 'REVIEW_PENDING',
  DOCUMENTS_REJECTED = 'DOCUMENTS_REJECTED',
  EXPIRED = 'EXPIRED',
}

export enum DocumentationType {
  UNKNOWN = 'UNKNOWN',
  EMPLOYED = 'EMPLOYED',
  INDEPENDENT = 'INDEPENDENT',
  LEGAL_PERSON = 'LEGAL_PERSON',
  PENSIONER = 'PENSIONER',
}

export class DocumentUploaded {
  constructor(
    public readonly id: DocumentId,
    public readonly documentationId: DocumentId,
    public readonly type: RiskStudyDocumentType
  ) {}
}

export class DocumentId {
  constructor(public readonly value: string) {}
}

export class DocumentsCompleted {
  constructor(public readonly value: boolean) {}
}

export class DocumentationId {
  public readonly _tag = 'DocumentationId';
  constructor(public readonly value: string) {}
}
